import { ReactNode } from "react";

import Button, { ButtonColor } from "../Button";
import Modal from "../Modal";

export default function ConfirmModal({
  title,
  subtitle,
  isOpen,
  actions,
  onClose,
}: {
  actions?: {
    color?: ButtonColor;
    isLoading?: boolean;
    label: string;
    onClick: () => void;
    plain?: boolean;
    size?: "lg" | "md" | "sm";
  }[];
  isOpen: boolean;
  onClose?: () => void;
  subtitle: ReactNode | string;
  title: ReactNode | string;
}) {
  return (
    <Modal
      title={title}
      subtitle={subtitle}
      isOpen={isOpen}
      width={400}
      noClose={!onClose}
      onClose={onClose ? onClose : () => {}}
    >
      <div>
        <div className="flex justify-end gap-3 p-2">
          {actions?.map((action) => (
            <Button
              key={action.label}
              isLoading={action.isLoading}
              color={action?.color}
              onClick={action.onClick}
              size={action?.size}
              plain={action?.plain ?? false}
            >
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </Modal>
  );
}
